import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { z } from "zod";

import { DataUI } from "@/components/data-ui";
import { $getPreviewSpec } from "@/server/actions/preview";

const searchSchema = z
	.object({
		key: z.string(),
	})
	.optional();

export const Route = createFileRoute("/preview/render")({
	validateSearch: searchSchema,
	component: PreviewRender,
	beforeLoad: ({ search }) => {
		const key = search?.key;

		if (!key) {
			throw notFound();
		}

		return { key };
	},
	loader: ({ context }) => {
		return {
			key: context.key,
		};
	},
});

function PreviewRender() {
	const { key } = Route.useLoaderData();
	const containerRef = useRef<HTMLDivElement>(null);

	const { data: spec } = useSuspenseQuery({
		queryKey: ["preview", "spec", key],
		queryFn: () => $getPreviewSpec({ data: { key } }),
		staleTime: 0,
		// @ts-expect-error
		select: (data) => data?.data,
	});

	useEffect(() => {
		if (spec && containerRef.current) {
			requestAnimationFrame(() => {
				containerRef.current?.setAttribute("data-preview-ready", "true");
			});
		}
	}, [spec]);

	if (!spec) {
		return <div>Preview not found</div>;
	}

	return (
		<div
			id="preview-container"
			ref={containerRef}
			style={{ width: 800, padding: 24, background: "white", overflow: "hidden" }}
		>
			<DataUI tree={spec} isStreaming={false} />
		</div>
	);
}
